import { FormControl, InputLabel, Select, SxProps } from '@mui/material';
import { Theme } from '@mui/system';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import BoldText from './BoldText';
import IconSelect from '../assets/images/icon-selectbox.svg';
import IconSelectOn from '../assets/images/icon-selectbox-on.svg';

type Props = {
  sx?: SxProps<Theme>;
  children: ReactNode;
  selectLabel?: string;
  control: any;
  name: string;
  label?: string;
  // onChange?: (e: { target: { value: any } }) => void;
  value?: string;
};

function StyledSelect({ name, label, sx, children, control, selectLabel }: Props) {
  /* 셀렉트박스 옵션 css */
  const MenuProps = {
    PaperProps: {
      sx: {
        maxHeight: '194px',
        marginTop: '2px',
        backgroundColor: '#FFFFFF',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#DEDEDE',
        borderRadius: 0,
        boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.12)',
        '&::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          width: '10%',
          height: '10%',
          background: '#a1a1a1',
          backgroundClip: 'padding-box',
          borderRadius: '999px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#e5e5e5',
          backgroundClip: 'padding-box',
          borderRadius: '999px',
        },
        '&>.MuiList-root': {
          paddingTop: 0,
          paddingBottom: 0,
        },
        '&>.MuiList-root>li': {
          minHeight: '32px',
          paddingTop: '6px',
          paddingRight: '15px',
          paddingBottom: '6px',
          paddingLeft: '15px',
          color: '#383F43',
          fontSize: '0.813rem',
          lineHeight: '1.538em',
          letterSpacing: '-0.26px',
        },
        '&>.MuiList-root>li.Mui-selected': {
          backgroundColor: '#ECF4FF',
          color: '#004CBD',
        },
      },
    },
  };

  return (
    <>
      {selectLabel ? (
        <BoldText
          text={selectLabel}
          sx={{ mr: 2 }}
        />
      ) : null}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            MenuProps={MenuProps}
            label={label}
            sx={{
              width: '100%',
              height: '34px',
              minWidth: '100px',
              padding: 0,
              '&>.MuiSelect-select': {
                width: '100%',
                height: 'auto',
                paddingTop: '8px',
                paddingRight: '38px !important',
                paddingBottom: '8px',
                paddingLeft: '12px',
                backgroundColor: '#FFFFFF',
                backgroundImage: `url(${IconSelect})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right center',
                backgroundSize: 'auto 18px',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#DADADA',
                color: '#383F43',
                fontSize: '0.813rem',
                lineHeight: '1.231em',
                letterSpacing: '-0.26px',
                fontFamily: 'NotoSansKR',
                borderRadius: '3px',
                cursor: 'pointer',
              },
              '&>.MuiSelect-select[aria-expanded=true]': {
                backgroundImage: `url(${IconSelectOn})`,
                borderColor: '#004CBD',
              },
              '&>.MuiSvgIcon-root': {
                display: 'none',
              },
              '&>.MuiOutlinedInput-notchedOutline': {
                display: 'none',
              },
              ...sx,
            }}
          >
            {children}
          </Select>
        )}
      ></Controller>
    </>
  );
}

export default StyledSelect;
